import { render, staticRenderFns } from "./DetailCarstock.vue?vue&type=template&id=3c75c6be&"
import script from "./DetailCarstock.vue?vue&type=script&lang=js&"
export * from "./DetailCarstock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports